import { FunctionComponent } from 'react';
import Image from 'next/image';

import { Props } from './types';

const LayoutImage: FunctionComponent<Props> = (props) => ((
    <Image {...props} />
));

export default LayoutImage;